import { render } from "./AlmRowDetailsRenderer.vue?vue&type=template&id=220e3372&scoped=true&ts=true"
import script from "./AlmRowDetailsRenderer.vue?vue&type=script&lang=ts"
export * from "./AlmRowDetailsRenderer.vue?vue&type=script&lang=ts"

import "./AlmRowDetailsRenderer.vue?vue&type=style&index=0&id=220e3372&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220e3372"]])

export default __exports__